'use client'
import * as React from 'react'
import Script from 'next/script'
import type { RegistrationSource } from '@repo/auth-utils'

import {
  GoogleOneTapWidget,
  googleOneTapScriptUrl as googleOneTapLoginScriptUrl,
} from '@repo/google-one-tap-login/widget'
import { useIsLoggedInQuery } from 'auth/hooks'

export const GlobalOneTapLogin = ({
  autoSelect = true,
  registrationSource,
}: {
  autoSelect?: boolean
  registrationSource?: RegistrationSource
} = {}) => {
  const isLoggedInQuery = useIsLoggedInQuery()
  const loggedIn = isLoggedInQuery.data
  const loading = isLoggedInQuery.isPending

  React.useEffect(() => {
    if (loggedIn && !loading) {
      const { google } = window
      if (google) {
        google.accounts.id.cancel()
      }
    }
  }, [loggedIn, loading])

  if (loading || loggedIn || isLoggedInQuery.isFetching) {
    return null
  }

  const redirectUrl = typeof window !== 'undefined' ? window.location.href : ''

  return (
    <>
      <GoogleOneTapWidget
        autoSelect={autoSelect}
        redirectUrl={redirectUrl}
        registrationSource={registrationSource}
      />
      <Script
        id="global-one-tap-login-script"
        src={googleOneTapLoginScriptUrl}
        strategy="lazyOnload"
      />
    </>
  )
}
